<template>
	<div style="width: 100%;height: 100%;background: #f8f8f9;">
		<Layout-Top style="background: #eceef1;" menuName="我的地址" prevUrl="/WeChat/Person/Info">
			<Icon class="slot" style="margin-top: -2px;" size="28" type="ios-add" />
		</Layout-Top>
		<Row type="flex" justify="center" align="center" style="height: 60px;padding-top: 16px;">
			<Col span="2">
			</Col>
			<Col span="22">
				<div>
					王金平,15508313366<br />
					四川省宜宾市珙县巡场镇狮子街1号
				</div>
			</Col>
		</Row>
	</div>
</template>
<script>
	import Top from '../../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Info/Address/index.vue